"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hyperImmunisedMessages = exports.combinedTransplantMessages = exports.urgencyMessages = exports.statusMessages = exports.subjectMessages = exports.HyperImmunised = exports.CombinedTransplant = exports.Urgency = exports.Status = exports.Subject = void 0;
const schema_1 = require("../../schema");
var Subject;
(function (Subject) {
    Subject["COMMITTEE_MEETING_OPINION"] = "COMMITTEE_MEETING_OPINION";
    Subject["OUTSIDE_COMMITTEE_OPINION"] = "OUTSIDE_COMMITTEE_OPINION";
    Subject["MEDICAL_PRACTITIONER_COMMENT"] = "MEDICAL_PRACTITIONER_COMMENT";
    Subject["PATIENT_INFO"] = "PATIENT_INFO";
})(Subject || (exports.Subject = Subject = {}));
var Status;
(function (Status) {
    Status["NEW"] = "NEW";
    Status["READY_FOR_COMMITTEE"] = "READY_FOR_COMMITTEE";
    Status["WAITING_FOR_MEDICAL_EXAMINATION"] = "WAITING_FOR_MEDICAL_EXAMINATION";
    Status["TRANSPLANTABLE"] = "TRANSPLANTABLE";
    Status["NON_TRANSPLANTABLE"] = "NON_TRANSPLANTABLE";
    Status["NATIONAL_HIGH_URGENT"] = "NATIONAL_HIGH_URGENT";
    Status["HIGH_URGENT"] = "HIGH_URGENT";
    Status["UNSUITABLE"] = "UNSUITABLE";
    Status["LTX_DONE"] = "LTX_DONE";
    Status["EXIT"] = "EXIT";
})(Status || (exports.Status = Status = {}));
var Urgency;
(function (Urgency) {
    Urgency["NO"] = "NO";
    Urgency["LOW"] = "LOW";
    Urgency["MEDIUM"] = "MEDIUM";
    Urgency["HIGH"] = "HIGH";
    Urgency["VERY_HIGH"] = "VERY_HIGH";
    Urgency["HIGHEST"] = "HIGHEST";
})(Urgency || (exports.Urgency = Urgency = {}));
var CombinedTransplant;
(function (CombinedTransplant) {
    CombinedTransplant["YES"] = "YES";
    CombinedTransplant["NO"] = "NO";
})(CombinedTransplant || (exports.CombinedTransplant = CombinedTransplant = {}));
var HyperImmunised;
(function (HyperImmunised) {
    HyperImmunised["YES"] = "YES";
    HyperImmunised["NO"] = "NO";
})(HyperImmunised || (exports.HyperImmunised = HyperImmunised = {}));
exports.subjectMessages = {
    [Subject.COMMITTEE_MEETING_OPINION]: {
        id: "ltx.patientCondition.subject.COMMITTEE_MEETING_OPINION",
        defaultMessage: "Bizottsági ülés jegyzőkönyve"
    },
    [Subject.OUTSIDE_COMMITTEE_OPINION]: {
        id: "ltx.patientCondition.subject.OUTSIDE_COMMITTEE_OPINION",
        defaultMessage: "Bizottság ülésen kívüli megjegyzése"
    },
    [Subject.MEDICAL_PRACTITIONER_COMMENT]: {
        id: "ltx.patientCondition.subject.MEDICAL_PRACTITIONER_COMMENT",
        defaultMessage: "Kezelőorvos megjegyzése"
    },
    [Subject.PATIENT_INFO]: {
        id: "ltx.patientCondition.subject.PATIENT_INFO",
        defaultMessage: "Beteg által közölt információ"
    }
};
exports.statusMessages = {
    [Status.NEW]: {
        id: "ltx.patientCondition.status.NEW",
        defaultMessage: "Új"
    },
    [Status.READY_FOR_COMMITTEE]: {
        id: "ltx.patientCondition.status.READY_FOR_COMMITTEE",
        defaultMessage: "Bizottsági Referálásra Kész"
    },
    [Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "ltx.patientCondition.status.WAITING_FOR_MEDICAL_EXAMINATION",
        defaultMessage: "Kiegészítő Vizsgálatra Vár"
    },
    [Status.TRANSPLANTABLE]: {
        id: "ltx.patientCondition.status.TRANSPLANTABLE",
        defaultMessage: "Transzplantálható"
    },
    [Status.NON_TRANSPLANTABLE]: {
        id: "ltx.patientCondition.status.NON_TRANSPLANTABLE",
        defaultMessage: "Nem Transzplantálható"
    },
    [Status.NATIONAL_HIGH_URGENT]: {
        id: "ltx.patientCondition.status.NATIONAL_HIGH_URGENT",
        defaultMessage: "Nemzeti High Urgent"
    },
    [Status.HIGH_URGENT]: {
        id: "ltx.patientCondition.status.HIGH_URGENT",
        defaultMessage: "High Urgent"
    },
    [Status.UNSUITABLE]: {
        id: "ltx.patientCondition.status.UNSUITABLE",
        defaultMessage: "Alkalmatlan"
    },
    [Status.LTX_DONE]: {
        id: "ltx.patientCondition.status.LTX_DONE",
        defaultMessage: "LTX megtörtént"
    },
    [Status.EXIT]: {
        id: "ltx.patientCondition.status.EXIT",
        defaultMessage: "Exit"
    }
};
exports.urgencyMessages = {
    [Urgency.NO]: {
        id: "ltx.patientCondition.urgency.NO",
        defaultMessage: "0x"
    },
    [Urgency.LOW]: {
        id: "ltx.patientCondition.urgency.LOW",
        defaultMessage: "1x"
    },
    [Urgency.MEDIUM]: {
        id: "ltx.patientCondition.urgency.MEDIUM",
        defaultMessage: "2x"
    },
    [Urgency.HIGH]: {
        id: "ltx.patientCondition.urgency.HIGH",
        defaultMessage: "3x"
    },
    [Urgency.VERY_HIGH]: {
        id: "ltx.patientCondition.urgency.VERY_HIGH",
        defaultMessage: "4x"
    },
    [Urgency.HIGHEST]: {
        id: "ltx.patientCondition.urgency.HIGHEST",
        defaultMessage: "5x"
    }
};
exports.combinedTransplantMessages = {
    [CombinedTransplant.YES]: {
        id: "ltx.patientCondition.combinedTransplant.YES",
        defaultMessage: "Igen"
    },
    [CombinedTransplant.NO]: {
        id: "ltx.patientCondition.combinedTransplant.NO",
        defaultMessage: "Nem"
    }
};
exports.hyperImmunisedMessages = {
    [HyperImmunised.YES]: {
        id: "ltx.patientCondition.hyperImmunised.YES",
        defaultMessage: "Igen"
    },
    [HyperImmunised.NO]: {
        id: "ltx.patientCondition.hyperImmunised.NO",
        defaultMessage: "Nem"
    }
};
const subject = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Subject.COMMITTEE_MEETING_OPINION),
    schema_1.Schema.singleChoiceItem(Subject.OUTSIDE_COMMITTEE_OPINION),
    schema_1.Schema.singleChoiceItem(Subject.MEDICAL_PRACTITIONER_COMMENT),
    schema_1.Schema.singleChoiceItem(Subject.PATIENT_INFO)
]);
const description = schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ltx", code: "description_of_patient_condition" });
const status = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Status.NEW),
    schema_1.Schema.singleChoiceItem(Status.READY_FOR_COMMITTEE),
    schema_1.Schema.singleChoiceItem(Status.WAITING_FOR_MEDICAL_EXAMINATION),
    schema_1.Schema.singleChoiceItem(Status.TRANSPLANTABLE),
    schema_1.Schema.singleChoiceItem(Status.NON_TRANSPLANTABLE),
    schema_1.Schema.singleChoiceItem(Status.NATIONAL_HIGH_URGENT),
    schema_1.Schema.singleChoiceItem(Status.HIGH_URGENT),
    schema_1.Schema.singleChoiceItem(Status.UNSUITABLE),
    schema_1.Schema.singleChoiceItem(Status.LTX_DONE),
    schema_1.Schema.singleChoiceItem(Status.EXIT)
])
    .interpretation({ vocab: "ltx", code: "patient_status" })
    .tag({ vocab: "snomed", code: "224238005" });
const urgency = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Urgency.NO),
    schema_1.Schema.singleChoiceItem(Urgency.LOW),
    schema_1.Schema.singleChoiceItem(Urgency.MEDIUM),
    schema_1.Schema.singleChoiceItem(Urgency.HIGH),
    schema_1.Schema.singleChoiceItem(Urgency.VERY_HIGH),
    schema_1.Schema.singleChoiceItem(Urgency.HIGHEST)
])
    .default(Urgency.NO)
    .interpretation({ vocab: "ltx", code: "urgency" });
const combinedTransplant = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CombinedTransplant.YES),
    schema_1.Schema.singleChoiceItem(CombinedTransplant.NO)
])
    .default(CombinedTransplant.NO)
    .interpretation({ vocab: "ltx", code: "combined_transplant" })
    .tag({ vocab: "snomed", code: "89780004" })
    .tag({ vocab: "snomed", code: "77465005" });
const hyperImmunised = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HyperImmunised.YES),
    schema_1.Schema.singleChoiceItem(HyperImmunised.NO)
])
    .default(HyperImmunised.NO)
    .interpretation({ vocab: "ltx", code: "hyper_immunised" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    subject,
    description,
    status,
    urgency,
    combinedTransplant,
    hyperImmunised
})
    .interpretation({ vocab: "ltx", code: "patient_condition" });
